export const siteAnnouncementsEntityName = 'SiteAnnouncements'

export interface SiteAnnouncementsEntity {
  uuid: string
  title: string
  preamble: string
  content: string
  author_avatar: string | null
  author_name: string
  publish_date: string
  display: boolean
  display_until: string
  visible: boolean
  target: TargetTypeEnum
}

export enum TargetTypeEnum {
  All = 'all',
  NonSaas = 'nonsaas',
  Saas = 'saas',
}

export const SITE_ANNOUNCEMENTS_LOADER = {
  deleteSiteAnnouncement: {
    id: 'deleteSiteAnnouncement',
  },
}
